import type { PageResponse } from './common'

export type DeviceAssetStatus = 'ACTIVE' | 'MAINTENANCE' | 'RETIRED' | 'DISPOSED'

export interface DeviceAsset {
  id: number
  assetCode: string
  customerName: string
  hospitalName: string
  department: string
  installLocation: string
  deviceName: string
  deviceModel: string
  deviceSerialNo: string
  manufacturer: string
  remark?: string
  createdAt: string
  updatedAt: string
  status?: DeviceAssetStatus | null
}

export interface CreateDeviceAssetRequest {
  customerName: string
  hospitalName: string
  department: string
  installLocation: string
  deviceName: string
  deviceModel: string
  deviceSerialNo: string
  manufacturer: string
  remark?: string
}

export interface CreateDeviceFromWorkOrderRequest {
  manufacturer: string
  remark?: string
}

export interface DeviceAssetPageParams {
  keyword?: string
  page?: number
  size?: number
}

export type DeviceAssetPageResponse = PageResponse<DeviceAsset>

export const DEVICE_STATUS_LABELS: Record<DeviceAssetStatus, string> = {
  ACTIVE: '在用',
  MAINTENANCE: '维修中',
  RETIRED: '已退役',
  DISPOSED: '已报废',
}
